<template>
  <ModalBody>
    <div class="expiring-licenses q-px-lg q-pt-lg bg-white-1 shadow3 border-radius-sm overflow-hidden">
      <AgGrid :options="options" :row-data="gridData" :context="context" @ready="agGrid = $event">
        <template #header>
          <Grid justify-content="end">
            <ShowHideCols :ag-grid="agGrid" />
          </Grid>
        </template>
      </AgGrid>

      <FormLicensePeriod
        :showing="showModalRenew"
        :license-period="renewableLicensePeriod"
        :renew-mode="true"
        :disable-properties="['publisher_id']"
        @close="closeFormModal('renew')"
        @refresh="getAndSetTableRows"
      />

      <FormLicensePeriod
        :showing="showModalEdit"
        :license-period="editableLicensePeriod"
        :edit-mode="true"
        :disable-properties="['publisher_id']"
        @close="closeFormModal('edit')"
        @refresh="getAndSetTableRows"
      />
    </div>
  </ModalBody>
</template>

<script>
import * as apiTo from '@/modular-api'
import { options } from './options'
// Components
import AgGrid from '@/ag-grid/AgGrid'
import FormLicensePeriod from '@components/forms/form-license-period/FormLicensePeriod'
import ModalBody from '../components/ModalBody'
import ShowHideCols from '@/ag-grid/components/show-hide-cols/ShowHideCols'

export default {
  components: {
    AgGrid,
    FormLicensePeriod,
    ModalBody,
    ShowHideCols
  },

  mixins: [options],

  props: {
    periodId: [Number, String]
  },

  data() {
    return {
      editableLicensePeriod: null,
      renewableLicensePeriod: null,
      showModalEdit: false,
      showModalRenew: false,
      gridData: null,
      agGrid: null,
      context: {}
    }
  },

  created() {
    this.getAndSetTableRows()
    this.context = { expiringLicensesCmp: this }
  },

  methods: {
    getCount() {
      return this.gridData.length
    },

    getAndSetTableRows() {
      this.$emit('set-loader', true)
      apiTo
        .GET_TASK_DATA('expiring-licenses')
        .then(({ data }) => {
          if (!data.result.length) this.$emit('make-count-0')
          else this.gridData = data.result
        })
        .finally(() => this.$emit('set-loader', false))
    },

    // access from ActionsColumn.vue
    edit(row) {
      this.$emit('set-loader', true)

      apiTo
        .GET_LICENSE_PERIOD(row.id)
        .then(({ data }) => {
          this.setLicensePeriodFor('editableLicensePeriod', data.result)
          this.showModalEdit = true
        })
        .finally(() => this.$emit('set-loader', false))
    },

    // access from ActionsColumn.vue
    createNew(row) {
      this.$emit('set-loader', true)

      apiTo
        .GET_LICENSE_PERIOD(row.id)
        .then(({ data }) => {
          this.setLicensePeriodFor('renewableLicensePeriod', data.result)
          this.showModalRenew = true
        })
        .finally(() => this.$emit('set-loader', false))
    },

    // access from ActionsColumn.vue
    dismiss(row) {
      this.$emit('set-loader', true)

      apiTo
        .DISMISS_TASK('expiring-licenses', row.id)
        .then(() => {
          if (this.gridData.length === 1) this.$emit('make-count-0')
          else {
            const index = this.gridData.findIndex(g => g.id === row.id)
            if (~index) this.gridData.splice(index, 1)
          }
        })
        .finally(() => this.$emit('set-loader', false))
    },

    setLicensePeriodFor(property, payload) {
      this[property] = {
        id: payload.id,
        previous_license_period_id: null, // missing in data
        license_id: payload.license.id,
        publisher_id: payload.license.publisher.id,
        name: payload.license.name,
        start_date: payload.start_date,
        end_date: payload.end_date,
        summary: payload.summary,
        subscriptions: payload.subscriptions,
        owner_id: payload.owner.id,
        license_file: payload.license_file,
        terms: payload.terms,
        status: payload.status,
        actions: payload.actions
      }
    },

    closeFormModal(modal) {
      if (modal === 'edit') this.showModalEdit = false
      if (modal === 'renew') this.showModalRenew = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins.scss';

.expiring-licenses {
  @include table-with-no-filters;

  height: calc(100vh - 180px);
}
</style>
